class CompactHeader extends HTMLElement {
  constructor() {
    super();
    this.headerHeight = 0;
    this.currentScrollTop = 0;
    this.onScrollHandler = this.onScroll.bind(this);
    this.mode = 'expanded';
    this.gallery = false;
  }

  connectedCallback() {
    this.gallery = document.querySelector('product-gallery');
    this.expandedHeader = document.querySelector('expanded-header');
    this.background = document.getElementById('compact-header-bg');
    this.globalBanner = document.querySelector('global-banner');
    this.headerHeight = this.expandedHeader.getBoundingClientRect().height;
    this.headerHeight += this.globalBanner ? this.globalBanner.getBoundingClientRect().height : 0;

    window.addEventListener('scroll', this.onScrollHandler, false);
    window.addEventListener('resize', this.onScrollHandler);
    if (this.gallery) {
      this.gallery.addEventListener('scroll', this.onScrollHandler, false);
    }
    this.snapHide();
    document.addEventListener('custom:accessible:true', (ev) => {
      this.background.setAttribute('aria-hidden', false);
    });
  }

  onScroll(e) {
    if (document.querySelector('html').dataset.pinned === '1') {
      return;
    }

    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let galleryTop = this.gallery ? this.gallery.scrollTop : 0;

    if (window.matchMedia('(max-width: 1199px)').matches && this.gallery && e.target.nodeName === 'PRODUCT-GALLERY') {
      scrollTop = galleryTop;
    }

    if (this.mode === 'expanded' && scrollTop > this.headerHeight) {
      this.expandedHeader.style.opacity = '0';
      this.mode = 'condensed';
      this.expandedHeader.setAttribute('data-mode', 'condensed');
      return;
    }

    if (this.mode === 'condensed' && scrollTop <= 0 && galleryTop <= 0) {
      this.expandedHeader.style.opacity = '1';
      this.mode = 'expanded';
      this.expandedHeader.setAttribute('data-mode', 'expanded');
      requestAnimationFrame(this.snapHide.bind(this));
      return;
    }

    if (scrollTop > this.currentScrollTop + 2 && scrollTop > 140) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop - 2 && scrollTop > 140) {
      requestAnimationFrame(this.reveal.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.getAttribute('aria-hidden') === 'true') return;
    if (document.body.classList.contains('accessible-design-mode')) return;

    [this, this.background].forEach((x) => {
      x.setAttribute('aria-hidden', true);
      x.classList.add('-translate-y-full');
    });
    waitForTransitionEnd(this, () => {
      [this, this.background].forEach((x) => {
        x.classList.replace('flex', 'hidden');
      });
    });
  }

  snapHide() {
    if (this.getAttribute('aria-hidden') === 'true') return;
    if (document.body.classList.contains('accessible-design-mode')) return;

    [this, this.background].forEach((x) => {
      x.setAttribute('aria-hidden', true);
      x.classList.remove('transition-transform');
      x.classList.add('-translate-y-full');
    });
    requestAnimationFrame(() => {
      [this, this.background].forEach((x) => {
        x.classList.add('transition-transform');
        x.classList.replace('flex', 'hidden');
      });
    });
  }

  reveal() {
    if (this.getAttribute('aria-hidden') === 'false') return;
    [this, this.background].forEach((x) => {
      x.setAttribute('aria-hidden', false);
      x.classList.replace('hidden', 'flex');
    });
    requestAnimationFrame(() => {
      [this, this.background].forEach((x) => {
        x.classList.remove('-translate-y-full');
      });
    });
  }
}

customElements.define('compact-header', CompactHeader);
